import React, { MouseEventHandler, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { useSelectGroupQuery } from "src/api/userAPI";
import { useAppSelector } from "src/store/actions/action";
import { setGroupType } from "src/store/reducers/userReduce";
import { theme } from "src/styles/theme";
import styled from "styled-components";

interface propsData {
  type?: string;
  add?: boolean;
  onClick?: MouseEventHandler<HTMLDivElement>;
}

const GroupItem = (props: propsData) => {
  const dispatch = useDispatch();

  const userInfo = useAppSelector((state) => state.userReduce.userInfo);

  // 초기 값 영역
  const [apiData, setApiData] = useState({
    groupApiData: [],
  });

  const { groupApiData } = apiData;

  // API 영역
  const groupAPI = useSelectGroupQuery({ userId: userInfo.user_id, type: props.type });

  useEffect(() => {
    if (props.type) {
      dispatch(setGroupType(props.type));
    }
  }, [props.type]);

  useEffect(() => {
    if (groupAPI.isSuccess) {
      setApiData({
        ...apiData,
        groupApiData: groupAPI.data,
      });
    }
  }, [groupAPI]);

  return (
    <>
      <GroupTitle>그룹 채널</GroupTitle>
      <StyledGroup>
        {groupApiData.map((v: any, i: number) => {
          return (
            <StyledGroupItem key={i}>
              {props.add ? (
                <Link to={"/manage-group/" + v.group_part_idx} state={{ groupName: v.group_name }}>
                  {v.group_name}
                </Link>
              ) : (
                <div
                  onClick={(e) => {
                    props.onClick!(e);
                  }}
                >
                  {v.group_name}
                </div>
              )}
            </StyledGroupItem>
          );
        })}
        {props.add && (
          <PageMoveLink>
            <Link to="/group-add">
              <span className="hidden">그룹설정으로 이동</span>
            </Link>
          </PageMoveLink>
        )}
      </StyledGroup>
    </>
  );
};

const GroupTitle = styled.p`
  padding: 0 15px 15px;
  font-size: 16px;
  font-weight: 500;
`;

const StyledGroup = styled.ul`
  overflow: hidden;
  overflow-x: scroll;
  ${({ theme }) => theme.flexBox.flexMixin("row", "flex-start", "center")}
  padding: 0 15px 15px;
  border-bottom: 1px solid ${({ theme }) => theme.color.linePrimary};
  &::-webkit-scrollbar {
    display: none; /* Chrome, Safari, Opera*/
  }
  > li {
    margin-right: 10px;
    &:last-child {
      margin-right: 0;
    }
  }
`;
const StyledGroupItem = styled.li`
  flex-shrink: 0;
  border-radius: 50%;
  background-color: ${({ theme }) => theme.color.main};
  ${({ theme }) => theme.flexBox.flexMixin("column", "center")}
  > a,
  > div {
    overflow: hidden;
    ${({ theme }) => theme.flexBox.flexMixin("row", "center", "center")}
    width: 60px;
    height: 60px;
    padding: 2px;
    text-align: center;
    color: #fff;
    font-size: 12px;
    line-height: 14px;
    word-break: break-all;
  }
`;

const PageMoveLink = styled.li`
  > a {
    position: relative;
    display: inline-block;
    width: 60px;
    height: 60px;
    border: 1px solid ${({ theme }) => theme.color.lineSecondary};
    border-radius: 30px;
    &::before {
      position: absolute;
      top: 50%;
      left: 50%;
      content: "";
      display: block;
      width: 1px;
      height: 17px;
      margin-top: -8px;
      background-color: ${({ theme }) => theme.color.lineSecondary};
    }
    &::after {
      position: absolute;
      top: 50%;
      left: 50%;
      content: "";
      display: block;
      width: 17px;
      height: 1px;
      margin-left: -8px;
      background-color: ${({ theme }) => theme.color.lineSecondary};
    }
  }
`;

export default GroupItem;
